<template>
  <v-layout fill-height style="height:100%;width:100%">
    <v-row style="height:100%;" no-gutters>
      <v-col cols="3">
        <v-card height="100%" color="white" style="pointer-events: auto;">
          <div style="height: 100%;width: 100%;position: absolute;">
            <v-item-group mandatory v-model="editingTab" v-if="!showAssetBrowser">
              <v-layout column style="position:absolute;right: -46px;">
                <v-item v-slot="{ active, toggle }">
                  <v-btn :color="active ? 'blue' : ''" fab small @click="toggle" ><v-icon>mdi-message-video</v-icon></v-btn>
                </v-item>
              </v-layout>
            </v-item-group>

            <v-layout column fill-height style="">
              <v-flex shrink>
                <v-card>
                  <span class="subtitle-1 pa-4" v-if="editingTab == 0" >Video Overides</span>
                </v-card>
              </v-flex>
              <v-flex style="height: 0px;overflow-y: auto;">
                <v-container class="" >
                  <v-row no-gutters class="pa-2">
                    <v-col cols="12" v-for="(overide,index) in value.videoMaterials" :key="index">
                      <v-card class="pa-2">
                        <v-row no-gutters align="middle">
                          <v-col cols="11">
                            <span class="font-weight-bold">Material Name</span>
                            <br/>
                            <span>{{ overide.targetMaterialName }}</span>
                            <br/>
                            <span class="font-weight-bold">Asset ID</span>
                            <br/>
                            <span>{{ overide.videoAssetId }}</span>
                          </v-col>
                          <v-col cols="1">
                            <v-btn color="red" block @click="RemoveOverideAtIndex(index)">
                              <v-icon>
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-btn block dark @click="showAssetBrowser = true">Add New +</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-flex>
            </v-layout>
          </div>
          <div style="height: 100%;width: 100%;position: absolute;background-color: white;" v-if="showAssetBrowser">
            <v-layout column fill-height style="">
              <v-flex shrink>
                <v-card class="pa-2">
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <v-btn small block @click="showAssetBrowser = false"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    </v-col>
                    <v-col class="ml-2 pb-4">
                      <span class="subtitle-1 pa-2">Select Asset</span>
                    </v-col>
                    <v-col cols="12" class="pb-2">
                      <v-select v-on:change="ResetSearch()" item-text="name" item-value="id" v-model="selectedAXPSection"  :items="sectionHeaders" label="Section" dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" class="pb-2">
                      <v-text-field v-on:change="ResetSearch()" v-model="selectedAXPTextFilter" label="Search Text" dense hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-flex>
              <v-flex style="height: 0px;overflow-y: auto;">
                <v-container class="" >
                  <v-row no-gutters class="pa-2">
                    <v-col 
                      cols="6" 
                      v-for="(asset, index) in searchResults.results" 
                      :key="index" class="pa-2"
                    >
                      <drag
                      style="pointer-events:initial;"
                      :transfer-data="asset"
                        >
                        <template slot="image">
                          <div >
                            <img style="max-height: 100px;max-width: 100px;" :src="(asset.thmUrl != null) ? asset.thmUrl : 'https://activstoredev.blob.core.windows.net/test/box.png'"/>
                          </div>
                        </template>
                        <AssetCard
                          class="light"
                          style="color:black;"
                          :asset="asset" 
                        ></AssetCard>
                      </drag>
                    </v-col>
                    <v-col cols="12">
                      <v-card height="40px" width="100px" color="transparent" flat>
                        <infinite-loading :identifier="infiniteIncrementor" @infinite="infiniteHandler">
                            <div slot="spinner">Loading...</div>
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                        </infinite-loading>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
  </template>
  
  <script>

  import { mapState } from 'vuex';
  import { mapMutations} from 'vuex'
  import InfiniteLoading from 'vue-infinite-loading';
  import axios from 'axios'
  import CONFIG from '@/appconfig.json'
  import { GetAuthorisationHeaderGroup} from '@/vuex/assetxphelpers'
  import AssetCard from '@/components/cards/AssetCard'

  export default {
    name: 'ModelEditor',
    components: {
      InfiniteLoading,
      AssetCard
    },
    props: {

      value: {
        type: Object
      }
      
    },
    computed: {

      ...mapState("assetxpstate", [
        "sectionHeaders",
      ]),

    },

    mounted:  function () {

    },
    
    data: () => ({

      editingTab : 0,
      showAssetBrowser : false,
      selectedAXPSection : null,
      selectedAXPTextFilter : "",
      infiniteIncrementor : 0,
      performingSearch : false,
      searchResults : {results : []}

    }),
    methods: {

      ResetSearch()
      {
        this.searchResults = {results : [], token : ""};
        this.infiniteIncrementor++;
      },
      RemoveOverideAtIndex(index)
      {
        this.$emit("OnRemoveVideoMaterial",index);
      },
      UpsertChanges()
      {
        this.$emit("OnChangedModel");
      },
      infiniteHandler($state) 
      {
        if(!this.performingSearch)
        {
          this.performingSearch = true;

          var searchParams = {
            textSearch : this.selectedAXPTextFilter,
            token : this.searchResults.token,
            sectionid : (this.selectedAXPSection != null) ? this.selectedAXPSection : ""
          };

          console.log("Searchiung with", searchParams)

          axios.post(CONFIG.platformEndpoints.assetxpapi +  'asset/search',searchParams, GetAuthorisationHeaderGroup())
          .then( (response) => {

            this.searchResults.results = response.data.results.concat(this.searchResults.results);
            this.searchResults.token = response.data.token;
            this.searchResults.hasNextPage = response.data.hasNextPage;

            this.performingSearch = false;
            if (this.searchResults.hasNextPage) 
            {
              $state.loaded();
            }
            else
            {
              $state.complete();
            }
          })
          
        }
      },
      
    },
    watch: {


      value : {

        immediate : true,
        handler(newVal)
        {
          console.log("Value for Model editor is:",newVal)
        }

      }
     
      
    }
  }
</script>